<form [formGroup]="organisationForm()" *transloco="let t; prefix: 'registration.page.organisationForm'">
  <div class="form-container">
    <htx-form-section
      [title]="t('sections.basicData')"
      [icon]="'domain'"
      [formGroup]="organisationForm()"
      [showErrorSummary]="false"
      [fieldLabels]="organisationFormFieldLabels()"
    >
      <div class="grid-two-columns">
        <htx-text-field-with-error
          [ctrl]="organisationForm().controls['legalName']"
          [label]="t('controls.legalName.label')"
          [required]="true"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
        <htx-text-field-with-error
          [ctrl]="organisationForm().controls['shortName']"
          [label]="t('controls.shortName.label')"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
        <htx-text-field-with-error
          [ctrl]="organisationForm().controls['legalForm']"
          [label]="t('controls.legalForm.label')"
          [required]="true"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
        <htx-text-field-with-error
          [ctrl]="organisationForm().controls['sector']"
          [label]="t('controls.sector.label')"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
        <htx-text-field-with-error
          [ctrl]="organisationForm().controls['website']"
          [label]="t('controls.website.label')"
          [placeholder]="'https://www.beispiel.de'"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
      </div>
    </htx-form-section>

    <htx-form-section
      [title]="t('sections.address')"
      [icon]="'location_on'"
      [formGroup]="organisationForm()"
      [showErrorSummary]="false"
      [fieldLabels]="organisationFormFieldLabels()"
    >
      <div class="grid-address grid-address-street">
        <htx-text-field-with-error
          [ctrl]="organisationForm().controls['street']"
          [label]="t('controls.street.label')"
          [required]="true"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
        <htx-text-field-with-error
          [ctrl]="organisationForm().controls['houseNumber']"
          [label]="t('controls.houseNumber.label')"
          [required]="true"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
      </div>
      <div class="grid-address grid-address-city">
        <htx-text-field-with-error
          [ctrl]="organisationForm().controls['postalCode']"
          [label]="t('controls.postalCode.label')"
          [required]="true"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
        <htx-text-field-with-error
          [ctrl]="organisationForm().controls['city']"
          [label]="t('controls.city.label')"
          [required]="true"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
      </div>
    </htx-form-section>

    <htx-form-section
      [title]="t('sections.description')"
      [icon]="'description'"
      [formGroup]="organisationForm()"
      [showErrorSummary]="false"
      [fieldLabels]="organisationFormFieldLabels()"
    >
      <div class="description-container">
        <htx-textarea-field-with-error
          [ctrl]="organisationForm().controls['description']"
          [label]="t('controls.description.label')"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-textarea-field-with-error>
        <div class="char-count">
          {{ descriptionCharCount() }} / {{ descriptionMaxLength }} Zeichen
        </div>
      </div>
    </htx-form-section>
  </div>
</form>
